/**
 * @name results.controller:horseTable
 * @description
 * # horseTable
 * Controller for horseTable block directive
 */
export default function ($scope,
                         userPreference
                        ) {
    'ngInject';

    $scope.generalInfo = {
        length: null,
        note: {
            isExists: null,
            value: null
        }
    };

    angular.extend($scope, window.horseData);
    delete window.horseData;

    /**
     * Returns pedigrees state
     * @return {Boolean}
     */
    $scope.getPedigreesState = () => userPreference.get(userPreference.TYPE_PEDIGREE);

    /**
     * Returns comments state
     * @return {Boolean}
     */
    $scope.getCommentsState = () => userPreference.get(userPreference.TYPE_COMMENTS);
}



// WEBPACK FOOTER //
// ./src/js/controllers/horseTable.js